"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FabricMapLayer = void 0;
const react_1 = __importStar(require("react"));
const react_mapbox_gl_1 = require("react-mapbox-gl");
const map_1 = require("../map");
const MapboxLayer_1 = __importDefault(require("./MapboxLayer"));
class FabricMapLayer extends react_1.PureComponent {
    constructor() {
        super(...arguments);
        this.setFeatureState = (hoverZoneID, stateName, setTo) => {
            const { idPrefix, map } = this.props;
            map.setFeatureState({
                source: `${idPrefix}-fabric-map-layer-source`,
                id: hoverZoneID,
            }, { [stateName]: setTo });
        };
        this.onMouseEnter = (e) => {
            const { disableHighlight, onHover } = this.props;
            const feature = e.features[0];
            if (!disableHighlight) {
                this.hovered = feature.id;
                this.setFeatureState(this.hovered, "hover", true);
            }
            if (onHover) {
                onHover(feature);
            }
        };
        this.onMouseLeave = () => {
            const { feature, onMouseLeave } = this.props;
            if (this.hovered) {
                this.setFeatureState(this.hovered, "hover", false);
            }
            this.hovered = undefined;
            if (onMouseLeave) {
                onMouseLeave(feature);
            }
        };
        this.onMouseClick = (e) => {
            const feature = e.features[0];
            const { onClick } = this.props;
            if (onClick) {
                onClick(feature);
            }
            e.originalEvent.cancelBubble = true;
        };
        this.render = () => {
            const { idPrefix, feature, paint } = this.props;
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_mapbox_gl_1.Source, { id: `${idPrefix}-fabric-map-layer-source`, geoJsonSource: { type: "geojson", data: feature } }),
                react_1.default.createElement(MapboxLayer_1.default, { id: `${idPrefix}-fabric-map-layer`, type: "fill", sourceId: `${idPrefix}-fabric-map-layer-source`, paint: Object.assign({ "fill-color": "#f2f2f2", "fill-antialias": true, "fill-opacity": [
                            "case",
                            ["boolean", ["feature-state", "hover"], false],
                            0.9,
                            ["boolean", ["feature-state", "selected"], false],
                            0.9,
                            0.5,
                        ], "fill-outline-color": "#ffffff" }, paint), onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave, onClick: this.onMouseClick }),
                react_1.default.createElement(MapboxLayer_1.default, { id: `${idPrefix}-fabric-map-layer-outline`, type: "line", sourceId: `${idPrefix}-fabric-map-layer-source`, paint: {
                        "line-color": "#ffffff",
                        "line-width": [
                            "case",
                            ["boolean", ["feature-state", "selected"], false],
                            3,
                            1,
                        ],
                    } })));
        };
    }
    componentDidUpdate() {
        const { feature, highlight } = this.props;
        this.setFeatureState(feature.id, "selected", !!highlight);
    }
}
exports.FabricMapLayer = FabricMapLayer;
exports.default = (0, map_1.withMap)(FabricMapLayer);
